<template>
  <el-form-item label="Час" class="time-in-row" required>
    <div class="time-in-row__time">
      <el-form-item prop="timeStart">
        <el-time-select
          v-model="timeStart"
          :picker-options="{
            start: timeStartFallback,
            step: '00:30',
            end: timeEndFallback,
          }"
          format="HH:mm"
          :disabled="timeStartDisabled"
          placeholder="Час початку"
          @change="sendData"
        />
      </el-form-item>

      <div style="margin: 0 10px">-</div>

      <el-form-item prop="timeEnd">
        <el-time-select
          v-model="timeEnd"
          :picker-options="{
            start: timeStart ? timeStart : timeStartFallback,
            step: '00:30',
            end: timeEndFallback,
            minTime: timeStart ? timeStart : timeStartFallback,
          }"
          format="HH:mm"
          :disabled="timeEndDisabled"
          placeholder="Час закінчення"
          @change="sendData"
        />
      </el-form-item>
    </div>
  </el-form-item>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { constants } from '@/utils/constants'

  import { firstNull } from '@/utils/functions'

  export default {
    data() {
      return {
        timeStart: '',
        timeEnd: '',
        TIMESTEP: constants.courcesTimeStep,
      }
    },
    props: {
      timeStartValue: [String, undefined],
      timeEndValue: [String, undefined],
      timeStartDisabled: Boolean,
      timeEndDisabled: Boolean,
    },
    computed: {
      ...mapGetters(['userSalon']),
      timeStartFallback() {
        return this.userSalon.timeStartHour
          ? `${firstNull(this.userSalon.timeStartHour)}:00`
          : constants.timeStartString
      },
      timeEndFallback() {
        return this.userSalon.timeEndHour
          ? `${firstNull(this.userSalon.timeEndHour)}:00`
          : constants.timeEndString
      },
    },
    watch: {
      timeStartValue: {
        immediate: true,
        handler(value) {
          if (!value) return

          this.timeStart = value
        },
      },
      timeEndValue: {
        immediate: true,
        handler(value) {
          if (!value) return

          this.timeEnd = value
        },
      },
    },
    methods: {
      sendData() {
        this.$emit('sendData', {
          timeStart: this.timeStart,
          timeEnd: this.timeEnd,
        })
      },
    },
  }
</script>

<style lang="scss" scoped>
  .time-in-row {
    &::v-deep .el-form-item__content {
      display: flex;
      flex-wrap: wrap;
      line-height: 1;

      @media screen and (min-width: 480px) {
        flex-wrap: nowrap;
      }

      .el-form-item {
        margin: 0;
        flex: 1 1 50%;

        &:last-child .el-input {
          margin-right: 0;

          @media screen and (min-width: 480px) {
            margin-right: 10px;
          }
        }

        .el-input {
          max-width: inherit;
        }
      }
    }

    .el-form-item {
      margin-bottom: 0;
    }

    .el-button {
      flex: 1;
      margin-top: 10px;
    }

    &__time {
      display: flex;
      align-items: center;

      .el-form-item {
        margin-bottom: 0 !important;
      }
    }
  }
</style>
